import { ContainerModule } from 'inversify';
import type { UploadDispatcher, MultipartUploadStrategy } from '@dealroadshow/file-uploader';
import { IUploadAdapter, ISocketProcessingAdapter, IUploadDispatcherFactory } from './interfaces';
import DITypes from './types';
import { UploadAdapter } from '../UploadAdapter';
import { EvercallSocketProcessingAdapter } from '../SocketProcessingAdapter';
import UploadDispatcherFactory from '../UploadDispatcherFactory';

export const FileUploadModule = new ContainerModule(({ bind }) => {
  bind<IUploadAdapter>(DITypes.UploadAdapter)
    .to(UploadAdapter)
    .inSingletonScope();

  bind<ISocketProcessingAdapter>(DITypes.SocketProcessingAdapter)
    .to(EvercallSocketProcessingAdapter)
    .inSingletonScope();

  bind<IUploadDispatcherFactory>(DITypes.UploadDispatcherFactory)
    .to(UploadDispatcherFactory)
    .inSingletonScope();

  bind<UploadDispatcher<MultipartUploadStrategy>>(DITypes.UploadDispatcher)
    .toDynamicValue(({ get }) => {
      return get<IUploadDispatcherFactory>(DITypes.UploadDispatcherFactory)
        .create();
    })
    .inSingletonScope();
});
